import type { EmployerInfo } from '~/types/hlx/employerInfo';
import {
  EMPLOYER_OWNERSHIP_STRUCTURE_OPTIONS,
  EMPLOYER_TYPE_OPTIONS,
  emptyEmployerRegistrationForm,
} from './employerInfoConstants';
import type { EmployerInfoValues } from './employerInfoSchema';

export type EmployerInfoUpsertPayload = {
  employerEin: string;
  legalEntityName: string;
  employerNpi: string;
  employerType: string;
  ownershipStructure: string;
  employerWebsite: string;
};

const emptyToString = (value: string | null | undefined) => value ?? '';

const optionFromValue = (
  value: string | null | undefined,
  options: typeof EMPLOYER_TYPE_OPTIONS
) => {
  if (!value) {
    return { label: '', value: '' };
  }
  return options.find((option) => option.value === value) ?? { label: value, value };
};

export const employerInfoToForm = (info?: EmployerInfo | null): EmployerInfoValues => {
  if (!info) {
    return emptyEmployerRegistrationForm;
  }

  return {
    legalEntityName: info.legalEntityName,
    employerEin: emptyToString(info.employerEin),
    employerNpi: emptyToString(info.employerNpi),
    employerType: optionFromValue(info.employerType, EMPLOYER_TYPE_OPTIONS),
    ownershipStructure: optionFromValue(
      info.ownershipStructure,
      EMPLOYER_OWNERSHIP_STRUCTURE_OPTIONS
    ),
    employerWebsite: emptyToString(info.employerWebsite),
  };
};

export const employerInfoFormToApi = (values: EmployerInfoValues): EmployerInfoUpsertPayload => ({
  employerEin: values.employerEin,
  legalEntityName: values.legalEntityName,
  employerNpi: values.employerNpi,
  employerType: values.employerType.value,
  ownershipStructure: values.ownershipStructure.value,
  employerWebsite: values.employerWebsite,
});
